// extracted by mini-css-extract-plugin
export default {"breadcrumb":"src-pages-Order-SubscriptionBuy-List-css-module__breadcrumb--Vardf"};